import * as ng from 'angular';

class WorkerAnagraficaInTdocResultController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'ArchiSmallServices'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
    ) {
        $scope.pageHeader = 'Anagrafica tDoc';
        $scope.pageSubHeader = 'Riepilogo';

        let result = store.get('WorkerAnagraficaInTdoc-Result');

        if (result === undefined) {
            $state.go('home.admin');
        }

        $scope.result = result;

        $scope.next = () => {
            $state.go('home.admin');
        };
    }

}

export const WorkerAnagraficaInTdocResultComponent: ng.IComponentOptions = {
    template: require('./worker-anagrafica-in-tdoc-result.html'),
    controller: WorkerAnagraficaInTdocResultController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/anagrafica-in-tdoc/worker-anagrafica-in-tdoc-result/worker-anagrafica-in-tdoc-result.ts